import { useContext, useEffect, useState } from "react";
import { Button, ButtonGroup, Card, Dropdown, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";

import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FieldType } from "../../constants";
import { formatLocaleDateString, truncate } from "../../utils";
import { LocaleDateRed } from "../localeDateRed";
import { UserNameWithEmail } from "../userNameWithEmail";
import { useDataTableContext } from "./hooks/useDataTableContext";

export const DataTableRowCell = ({
	dropDownButtons,
	value,
	render,
	column,
	row,
}) => {
	const { setOrgModalAction, setInitialModalData } = useDataTableContext();
	const [boolValue, setBoolValue] = useState(value);

	useEffect(() => {
		setBoolValue(value);
	}, [value]);

	let isDisabled = column.isDisabledFn
		? column.isDisabledFn(row.original)
		: false;

	switch (column.type) {
		case FieldType.URL:
			if (isDisabled) {
				return <span className="text-muted">{render("Cell")}</span>;
			}
			const linkRoute = column.linkFormat(row.original);
			if (linkRoute === null) return render("Cell");

			return (
				<Card.Link
					as={Link}
					to={linkRoute}
					className={`fw-normal text-decoration-underline`}
				>
					{render("Cell")}
				</Card.Link>
			);
		case FieldType.BUTTON_DROPDOWN:
			if (dropDownButtons.length === 0) {
				return null;
			} else if (dropDownButtons.length === 1) {
				return dropDownButtons;
			}
			return (
				<Dropdown
					as={ButtonGroup}
					onClick={(e) => {
						e.stopPropagation();
					}}
				>
					<Dropdown.Toggle
						as={Button}
						variant="link"
						className="text-dark pb-0 "
						style={{ marginBottom: "-0.2em", paddingTop: "0.2em" }}
					>
						<span className="icon icon-sm">
							<FontAwesomeIcon
								icon={faCog}
								className="icon-dark"
							/>
						</span>
					</Dropdown.Toggle>
					<Dropdown.Menu>{dropDownButtons}</Dropdown.Menu>
				</Dropdown>
			);
		case FieldType.TOGGLE_SWITCH:
			let onClick = column.onClick
				? () => {
						setBoolValue(!boolValue);
						column.onClick({ boolValue, data: row.original });
				  }
				: null;

			if (column.action) {
				onClick = () => {
					setInitialModalData([
						JSON.parse(JSON.stringify(row.original)),
					]);
					setOrgModalAction(column.action);
				};

				return (
					<Form.Switch
						checked={value}
						disabled={isDisabled}
						onChange={onClick}
						type="switch"
					/>
				);
			}

			return (
				<Form.Switch
					checked={boolValue}
					disabled={!onClick || isDisabled}
					onChange={onClick}
					type="switch"
				/>
			);
		case FieldType.DATE:
			return formatLocaleDateString(value);
		case FieldType.DATE_EXPIRED:
			return <LocaleDateRed date={value} />;
		case FieldType.TIME_DIFF: {
			if (!value) return "";
			// ReactTimeAgo expects a Date/number, not a string.
			const timeDiffDate = new Date(value);
			return isNaN(timeDiffDate.getTime()) ? (
				""
			) : (
				<ReactTimeAgo date={timeDiffDate} />
			);
		}
		case FieldType.USER:
			return <UserNameWithEmail {...value} />;
		case FieldType.SPECIAL_RENDER:
			return render("Cell");
		case FieldType.NUMBER:
		case FieldType.STRING:
		default: {
			if (value && typeof value === "string")
				return truncate(value.toString(), 75);
			else return render("Cell");
		}
	}
};
